import { groupBy } from "ramda";

const generateIntervals = (date, step) => {
	let i = 0;
	const minutesPerDay = 60 * 24;
	const intervals = [];
	const midnight = date.startOf("day");
	while (i < minutesPerDay) {
		intervals.push(midnight.clone().minute(i));
		i += step;
	}
	return intervals;
};

const withinInterval = (startTimes) => (interval) =>
	startTimes.filter(
		(iv) =>
			iv.isBetween(interval.from, interval.to, "minute", "[)") &&
			interval.reservable
	);

const isInTheFuture = (today) => (time) => today.isBefore(time, "minute");

const excludeReservedHours = (reserves) => (t) =>
	!reserves.some((r) => t.isBetween(r.from, r.to, "minute", "[)"));

export const mapOfficeHoursToBlocks =
	(today, delta, reserves) => (officeHours) => {
		if (!officeHours.length) return [];

		const day = today.clone().add(delta, "d");
		const step = 15;
		const ivs = generateIntervals(day, step);
		return officeHours
			.filter((oh) => oh.weekday === day.weekday() + 1)
			.flatMap(withinInterval(ivs))
			.map((oh) => {
				return oh;
			})
			.filter(excludeReservedHours(reserves))
			.filter(isInTheFuture(today))
			.sort((iv0, iv1) => iv0 - iv1)
			.map((iv) => ({
				from: iv,
				to: iv.clone().add(step.toString(), "m"),
			}));
	};

export const groupBlocks = groupBy((block) => {
	const hour = block.from.hour();
	if (hour < 12) return "Mañana";
	if (hour < 19) return "Tarde";
	return "Vespertino";
});
